const QuestionIcon = () => {
    return (
        <i className="fa-solid fa-circle-question"></i>
    )
}

export default QuestionIcon;